<template>
  <!-- ユーザ追加 -->
  <div id="AppUserManagementAddUserContents">
    <template :data="data">
      <!-- 上部余白 -->
      <div style="height: 10px;" />
      <!--ユーザ情報 -->
      <b-field
        label="点検担当者コード"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('code')}"
        :message="errors.first('code')"
      >
        <b-input
          v-model="data.code"
          name="code"
          data-vv-as="点検担当者コード"
          v-validate="'alphaUpper_num|max:5'"
          maxlength="5"
        ></b-input>
      </b-field>
      <b-field
        label="姓"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('lastName')}"
        :message="errors.first('lastName')"
      >
        <b-input
          v-model="data.lastName"
          name="lastName"
          data-vv-as="姓"
          v-validate="'required|max:50'"
          maxlength="50"
        ></b-input>
      </b-field>
      <b-field
        label="姓（カナ）"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('lastNameKana')}"
        :message="errors.first('lastNameKana')"
      >
        <b-input
          v-model="data.lastNameKana"
          name="lastNameKana"
          data-vv-as="姓（カナ）"
          v-validate="'required|katakana|max:50'"
          maxlength="50"
        ></b-input>
      </b-field>
      <b-field
        label="名"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('firstName')}"
        :message="errors.first('firstName')"
      >
        <b-input
          v-model="data.firstName"
          name="firstName"
          data-vv-as="名"
          v-validate="'required|max:50'"
          maxlength="50"
        ></b-input>
      </b-field>
      <b-field
        label="名（カナ）"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('firstNameKana')}"
        :message="errors.first('firstNameKana')"
      >
        <b-input
          v-model="data.firstNameKana"
          name="firstNameKana"
          data-vv-as="名（カナ）"
          v-validate="'required|katakana|max:50'"
          maxlength="50"
        ></b-input>
      </b-field>
      <b-field
        label="営業所"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('officeCode')}"
        :message="errors.first('officeCode')"
      >
        <b-select
          expanded
          v-model="selectedOffice"
          name="officeCode"
          data-vv-as="営業所"
          data-vv-validate-on="input"
          v-validate="'required'"
        >
          <option />
          <option
            v-for="office in officeMaster"
            :value="office.officeCode"
            :key="office.officeCode"
          >{{ office.officeName }}</option>
        </b-select>
      </b-field>
      <b-field label="電話番号(直通)" labelPosition="on-border">
        <b-input v-model="data.officePhoneNumber" :readonly="true"></b-input>
      </b-field>
      <b-field
        label="電話番号(携帯)"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('mobilePhoneNumber')}"
        :message="errors.first('mobilePhoneNumber')"
      >
        <b-input
          v-model="data.mobilePhoneNumber"
          name="mobilePhoneNumber"
          data-vv-as="電話番号(携帯)"
          v-validate="'max:20'"
        ></b-input>
      </b-field>
      <b-field
        label="メールアドレス"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('email')}"
        :message="errors.first('email')"
      >
        <b-input
          v-model="data.email"
          name="email"
          data-vv-as="メールアドレス"
          v-validate="'required|email|max:256'"
          maxlength="256"
        ></b-input>
      </b-field>
      <b-field
        label="権限"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('role')}"
        :message="errors.first('role')"
      >
        <b-select
          expanded
          v-model="data.role"
          name="role"
          data-vv-as="権限"
          data-vv-validate-on="input"
          v-validate="'required|selectRange:1:7'"
        >
          <option :value="4">点検者</option>
          <option :value="3">点検管理者</option>
          <option :value="5">GSS管理者</option>
          <option :value="6">営業管理者</option>
          <option :value="2">コールセンター</option>
          <option :value="7">待機当番のみ</option>
          <option :value="1">システム管理者</option>
        </b-select>
      </b-field>
      <b-field
        label="役職"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('positionCode')}"
        :message="errors.first('positionCode')"
      >
        <b-select
          expanded
          v-model="selectedPosition"
          name="positionCode"
          data-vv-as="役職"
          data-vv-validate-on="input"
          v-validate="'required'"
        >
          <option
            v-for="position in positionMaster"
            :value="position.positionCode"
            :key="position.positionCode"
          >{{ position.positionName }}</option>
        </b-select>
      </b-field>
      <!-- 下部余白 -->
      <div style="height: 10px;" />
    </template>
  </div>
</template>

<script>
var data = [];
var officeMaster = [];
var positionMaster = [];
export default {
  name: "AppUserManagementAddUserContents",
  props: ["isSaveComplete"],
  methods: {
    officePhoneFilter: function(value) {
      var officeElement = this.officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.phoneNumber;
      }
      return "";
    },
    validation: function(event) {
      // バリデータイベント
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$props.isSaveComplete = true;
        } else {
          scrollTo(0, 0);
        }
      });
    },
    doClear: function(event) {
      this.data.code = "";
      this.data.lastName = "";
      this.data.lastNameKana = "";
      this.data.firstName = "";
      this.data.firstNameKana = "";
      this.data.officeCode = "";
      this.data.officePhoneNumber = "";
      this.data.mobilePhoneNumber = "";
      this.data.email = "";
      this.data.role = "";
      this.selectedPosition = "";
      this.selectedOffice = "";
    },
    doSave: function(event) {
      var excuteApi = this.setUserInfoPOST;
      var successCallBack = this.setUserInfoPOSTSuccess;
      var errorCallBack = this.setUserInfoPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setUserInfoPOST: function(client) {
      if (this.data.code == "") {
        return client.apis.apiMaster.setUserInfoPOST({
          body: {
            lastName: this.data.lastName,
            lastNameKana: this.data.lastNameKana,
            firstName: this.data.firstName,
            firstNameKana: this.data.firstNameKana,
            officeCode: this.data.officeCode,
            officePhoneNumber: this.data.officePhoneNumber,
            mobilePhoneNumber: this.data.mobilePhoneNumber,
            email: this.data.email,
            role: this.data.role,
            positionCode: this.selectedPosition
          }
        });
      } else {
        return client.apis.apiMaster.setUserInfoPOST({
          body: {
            code: this.data.code,
            lastName: this.data.lastName,
            lastNameKana: this.data.lastNameKana,
            firstName: this.data.firstName,
            firstNameKana: this.data.firstNameKana,
            officeCode: this.data.officeCode,
            officePhoneNumber: this.data.officePhoneNumber,
            mobilePhoneNumber: this.data.mobilePhoneNumber,
            email: this.data.email,
            role: this.data.role,
            positionCode: this.selectedPosition
          }
        });
      }
    },
    setUserInfoPOSTSuccess: function(result) {
      this.showSuccess(result);
    },
    setUserInfoPOSTError: function(error) {
      this.showErrorMessage(error);
    }
  },
  data() {
    officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    positionMaster = JSON.parse(sessionStorage.getItem("positionMaster"));
    data.code = "";
    return {
      data,
      selectedOffice: "",
      selectedPosition: "",
      officeMaster,
      positionMaster
    };
  },
  computed: {},
  watch: {
    selectedOffice(value) {
      data.officeCode = value;
      data.officePhoneNumber = this.officePhoneFilter(value);
    },
    selectedPosition(value) {
      this.data.positionCode = value;
    }
  },
  created: function() {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppUserManagementAddUserContents.vue